import { createContext } from 'react';

const occasionAnswer = JSON.parse(sessionStorage.getItem('occasionAnswer'));

export const OccasionContext = createContext({
  answer: occasionAnswer ? occasionAnswer : '',
  setAnswer: answer => {},
});
